import { normalizeWorkspace, SCHEMA_VERSION } from '../../contracts/schemas.js'

export const LEGACY_KEYS = Object.freeze({
  workspace: 'iwb_web_workspaces',
  config: 'iwb_web_cfg',
  prompts: 'iwb_web_prompts',
  groups: 'iwb_web_groups',
  groupGroups: 'iwb_web_groupgroups',
  outputs: 'iwb_web_outputs',
})

function parse(raw) {
  if (raw == null || raw === '') return null
  try { return JSON.parse(raw) } catch { return null }
}

export function readLegacyWorkspace(storage) {
  const raw = parse(storage?.getItem?.(LEGACY_KEYS.workspace))
  if (!raw) return { ok: true, migrated: false, value: normalizeWorkspace(null) }
  const version = Number(raw.schemaVersion || 0)
  if (version > SCHEMA_VERSION.workspace) return { ok: false, code: 'unsupported-schema', error: '旧工作台版本过新' }
  return { ok: true, migrated: version !== SCHEMA_VERSION.workspace, value: normalizeWorkspace(raw) }
}

export function createWorkspaceRepository({ storage = globalThis.localStorage } = {}) {
  return {
    load() { return readLegacyWorkspace(storage) },
    save(value) {
      const normalized = normalizeWorkspace(value)
      storage?.setItem?.(LEGACY_KEYS.workspace, JSON.stringify(normalized))
      return { ok: true, value: normalized }
    },
  }
}
